import type { StatePersister, VersionedState } from './types'

export interface LocalStoragePersisterDeps {
    localStorageKey: string
    expectedVersion: number
}

export class LocalStoragePersister<State extends VersionedState>
    implements StatePersister<State>
{
    constructor(private readonly deps: LocalStoragePersisterDeps) {}

    clear: StatePersister<State>['clear'] = () => {
        localStorage.removeItem(this.deps.localStorageKey)
    }

    hydrate: StatePersister<State>['hydrate'] = () => {
        try {
            const raw = localStorage.getItem(this.deps.localStorageKey)
            if (!raw) return null
            const parsed = JSON.parse(raw) as State
            return parsed
        } catch {
            return null
        }
    }

    persist: StatePersister<State>['persist'] = (state) => {
        localStorage.setItem(this.deps.localStorageKey, JSON.stringify(state))
    }
}
